import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * isSidebarExpandedAtom (desktop)
 * isSidebarOpenAtom (mobile)
 */
export const isSidebarExpandedAtom = atomWithStorage(
  'isSidebarExpanded',
  false,
  undefined,
  { getOnInit: true }
);
export const isSidebarOpenAtom = atom<boolean>(false);
export const submenuAtom = atomWithStorage('isSubmenuExpanded', {
  Internal: false
});
